import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
import logoImage from '!url-loader!./assets/scandgate.svg';

import styles from './header.scss';

const Header = ({ isOpen, handleMenuToggle, handleMenuItemClick }) => {
  if (typeof window !== 'undefined' && window.document.body) {
    if (isOpen) {
      window.document.body.classList.add('with-sidebar');
    } else {
      window.document.body.classList.remove('with-sidebar');
    }
  }

  return (
    <header className={styles.header}>

      <div className={styles.headerContainer}>
        <div className={`${styles.logoContainer}`}>
          <NavLink to="/">
            <img src={logoImage} alt="ScandGate AB" className={styles.logo} />
          </NavLink>
        </div>

        <a
          href="#menu"
          className={`${styles.headerIcon}`}
          id="header__icon"
          onClick={handleMenuToggle}
        >
          <span className={`${styles.headerIconText}`}>Meny</span>

          <span className={`${styles.burger1}`} />
          <span className={`${styles.burger2}`} />
          <span className={`${styles.burger3}`} />
        </a>

        <nav className={`${styles.menu}`}>
          <NavLink
            to="/helpdesk/"
            activeClassName={styles.active}
            onClick={handleMenuItemClick}
          >
            <div className={`${styles.itemInner}`}>
              Helpdesk
            </div>
          </NavLink>
          <NavLink
            to="/kontakta-oss/"
            activeClassName={styles.active}
            onClick={handleMenuItemClick}
          >
            <div className={`${styles.itemInner}`}>
                Kontakt
              </div>
          </NavLink>
        </nav>

      </div>
    </header>
  );
};

Header.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleMenuToggle: PropTypes.func.isRequired,
  handleMenuItemClick: PropTypes.func.isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./blocks/Header/component.js